import React, { useEffect } from "react";
import { Button, Form } from "react-bootstrap";
import Flatpickr from "react-flatpickr";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import Select from "react-select";
import { openModal } from "../../../../slices/common/reducer";
import { useDispatch, useSelector } from "react-redux";
import { getAllAg } from "../../../Order/Orders/OrderService";
import { downloadReports } from "../../ReportService";
import { RPT_FROM_DATE, RPT_TO_DATE } from "../../../../Utils/FilterDateKeys";
import {
  setReportForm,
  setAgName,
} from "../../../../slices/reports/reportsSlice";
import {
  filterDateOptions,
  handleFilterDateChange,
  handleFlatpickerClose
} from "../../../../Utils/CommonUtils";

// Selecting this sends no ag_name to the API, so the report covers every AG at once
const ALL_AG_OPTION = { label: "All AG", value: "ALL" };

const DownloadModal = () => {
  const dispatch = useDispatch();
  const modalShow = useSelector((state) => state.common.modalShow);
  const selectedUser = useSelector((state) => state.header.selectedUser);
  const form = useSelector((state) => state.reports.form);
  const agName = useSelector((state) => state.reports.agName);

  const [agOptions, setAgOptions] = React.useState([]);
  const [agLoading, setAgLoading] = React.useState(false);

  useEffect(() => {
    const fetchAgOptions = async () => {
      if (!selectedUser?.owner_id) return;

      setAgLoading(true);
      try {
        const response = await getAllAg(selectedUser.owner_id);

        const options = [ALL_AG_OPTION, ...response];
        setAgOptions(options);
      } catch (error) {
        setAgOptions([ALL_AG_OPTION]);
      } finally {
        setAgLoading(false);
      }
    };

    if (modalShow) {
      fetchAgOptions();
    }
  }, [modalShow, selectedUser?.owner_id]);

  const handleClose = () => {
    const currentDate = new Date().toISOString().split("T")[0];
    dispatch(openModal(false));
    dispatch(setAgName({}));
    dispatch(setReportForm({ name: RPT_FROM_DATE, value: currentDate }));
    dispatch(setReportForm({ name: RPT_TO_DATE, value: currentDate }));
  };
  const isAllAg = agName?.value === ALL_AG_OPTION.value;
  const hasDateRange = Boolean(form[RPT_FROM_DATE] && form[RPT_TO_DATE]);
  // pulling every AG without a date range would dump the whole order history in one go
  const needsDateRange = isAllAg && modalShow.type === "ODR" && !hasDateRange;

  const handleDownloadReports = () => {
    const entityType = modalShow.type;

    downloadReports(
      entityType === "ODR" ? form[RPT_FROM_DATE] : undefined,
      entityType === "ODR" ? form[RPT_TO_DATE] : undefined,
      isAllAg ? undefined : agName?.label,
      entityType
    );

    handleClose();
  };
  return (
    <Modal
      isOpen={modalShow}
      centered
      backdrop="static"
      keyboard={false}
      className="border-0"
      modalClassName="modal fade zoomIn"
      toggle={handleClose}
    >
      <ModalHeader toggle={handleClose}>
        {modalShow.type === "ODR" ? "Order Report" : "AGM Report"}
      </ModalHeader>
      <ModalBody>
        <Form>

          <Form.Group className="mb-3" controlId="agName">
            <Form.Label className="fw-semibold">AG Name</Form.Label>
            <Select
              options={agOptions}
              value={
                agOptions.find((option) => option.value === agName?.value) || null
              }
              onChange={(selectedOption) => dispatch(setAgName(selectedOption))}
              isLoading={agLoading}
              isClearable
              placeholder="Select AG Name"
            />
          </Form.Group>


          {modalShow.type === "ODR" && (
            <Form.Group className="mb-3" controlId="dateRange">
              <Form.Label className="fw-semibold">Date Range</Form.Label>
              <Flatpickr
                className="form-control border-lightgrey"
                placeholder="Select date range"
                data-input
                   options={{
    ...filterDateOptions,
    onClose: (selectedDates) =>
      handleFlatpickerClose(selectedDates, setReportForm, RPT_FROM_DATE, RPT_TO_DATE),
  }}



                value={[
                  form[RPT_FROM_DATE] ? new Date(form[RPT_FROM_DATE]) : null,
                  form[RPT_TO_DATE] ? new Date(form[RPT_TO_DATE]) : null,
                ]}

                onChange={(e) =>
                  handleFilterDateChange(e, setReportForm, RPT_FROM_DATE, RPT_TO_DATE)
                }
              />
              {needsDateRange && (
                <Form.Text className="text-danger">
                  Select a date range to download the report for all AGs.
                </Form.Text>
              )}
            </Form.Group>
          )}
        </Form>
      </ModalBody>

      <ModalFooter>
        <Button
          variant="primary"
          disabled={
            !agName?.value || needsDateRange
          }
          onClick={handleDownloadReports}
        >
          Download
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default DownloadModal;
